<template>
  <div v-if="!loading && suggestions.length">
    <template v-for="(suggestion, index) in suggestions">
      <ai-suggestion-tag
        :key="index"
        :ref="`pillSuggestion${index}`"
        :selected="isSuggestionSelected(suggestion)"
        class="mr-2 cursor-pointer"
        closable
        @click="onClick(suggestion)"
        @close="$emit('close', index)"
      >
        {{ suggestion.description }}
      </ai-suggestion-tag>
    </template>
  </div>
</template>

<script>
import AiSuggestionTag from '@/views/Home/StoryMode/Components/AiBuddy/AiSuggestionTag.vue'
import { aiPillAnimation } from '@/helpers/animations'

export default {
  name: 'AiSuggestionBasicParser',

  components: { AiSuggestionTag },

  props: {
    value: {
      required: true,
      validator: value => typeof value === 'object' || value === null
    },

    suggestions: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    loading (newValue) {
      if (!newValue) {
        if (this.suggestions) {
          setTimeout(() => {
            this.suggestions.forEach((item, index) => {
              const element = this.$refs[`pillSuggestion${index}`]
              if (element) {
                aiPillAnimation(element[0].$el, index)
              }
            })
          }, 1)
        }
      }
    }
  },

  methods: {
    onClick (suggestion) {
      this.$emit('input', suggestion)
      this.$emit('click', suggestion)
    },

    isSuggestionSelected (suggestion) {
      return this.value === suggestion
    }
  }
}
</script>
